
import OrderDetail from '~/pages/_lang/account/order/_id.vue'
export default OrderDetail
